/*
    *    Controller to show pre_production devicegroup list view
    *    Triggered via:
    *        globalCh.request('show_pre_production_devicegroups', {{PRODUCT}});
    *    Arguments:
    *        PRODUCT: Object. Backbone Model extended v5API "Model", specifically instance of models/v5/products.js
*/

//    empty_template: '<h3>No Test Production Device Groups</h3>' +
//    'To create a new Test Production Device Group, click on the Create Device Group button.'



import Radio from 'backbone.radio';
import ProductionDevicegroupItemView from '@/views/list_item/dut_device_group';
import Button from '@/views/button';
import ListView from '@/views/modules/list_view';
import EmptyView from '@/views/list_item/dut_device_group_empty';

var globalCh = Radio.channel('global');
var routerCh = Radio.channel('router');

var DG_TYPE = 'dut_devicegroup';

function show_pre_production_devicegroups(product) {
    var app_container = globalCh.request('app_layout');
    var active_account = globalCh.request('active_account');
    var primary_account = globalCh.request('primary_account');

    let enabled = active_account.permits(primary_account, 'create_factory_devicegroup');
    var create_button = Button.extend({
        text: 'Create New DUT Group',
        icon: 'fa fa-plus-circle',
        primary: true,
        enabled: enabled,
        enabled_tooltip: 'Create a new DUT Device Group',
        disabled_tooltip: 'You do not have permission to create a DUT Device Group',
        action: function() {
            globalCh.request('show_create_' + DG_TYPE, product, DG_TYPE);
        }
    });

    let container_view = new ListView({
        title: 'DUT Device Groups',
        request_data: {
            'filter[product.id]': product.id,
            'filter[owner.id]': active_account.id,
            'filter[type]': DG_TYPE,
            'include': 'current_deployment,min_supported_deployment',
            'page[size]': 15,
            'sort': '-deployment'
        },
        empty_view: EmptyView,
        child_view: ProductionDevicegroupItemView.extend({expandable: false}),
        create_button: create_button,
        type: DG_TYPE,
        product: product
    });

    app_container.showChildView('container', container_view);

    product.counts.fetch();

    // Here and below is our normal navigation stuff

    // Breadcrumb Menu
    globalCh.request('set_selection', { type: 'dut', id: product.id, v5_object: product, area: 'production' } );

    // Left Nav
    globalCh.request('show_production_zone_secondary_nav', product, { selected: 'dut_devicegroup' });

    // Router
    routerCh.request('set_location', 'product_devicegroups', product, 'dut_devicegroup');
}

export default show_pre_production_devicegroups;






